<i-assistance
  [phone]="config?.phone"
  [email]="config?.email"
  [guideMode]="userGuides?.length"
  (guideClick)="openUserGuideModal = true"></i-assistance>
<div class="container mt-4">
  <i-title [text]="'assistance.releaseNotes' | translate" [level]="'2'"></i-title>
  @for (version of versionsList; track $index) {
    <div class="changelog__line border-bottom py-3">
      <div class="d-flex d-block-on-mobile justify-content-between align-items-center">
        <div class="d-flex d-block-on-mobile align-items-center">
          <p class="mb-0">
            <strong>
              {{ 'assistance.version' | translate }} {{ version }}
              @if (version === actualVersion) {
                <i class="bi bi-star-fill text-warning me-2"></i>
              }
            </strong>
          </p>
        </div>
        <i-button
          [text]="'assistance.viewReleaseNotes' | translate"
          styleClass="blue"
          icon="bi bi-file-earmark-pdf-fill"
          (click)="openVersionInfos(version)">
        </i-button>
      </div>
    </div>
  }
</div>

@if (openUserGuideModal) {
  <i-modal
    [visible]="openUserGuideModal"
    [header]="modalHeaderUserGuide"
    [modalParameters]="modalParamsUserGuide"
    (emitterOnVisibleChange)="openUserGuideModal = false">
    <section class="releases">
      <div class="row">
        <div class="col-12">
          <strong> {{ 'assistance.PDF' | translate }} </strong>
        </div>
        @for (item of userGuides; track item) {
          <div class="col-md-4">
            <div class="file__info">
              <a class="file__container" (click)="save(item)">
                <i class="file__icon icon bi bi-file-pdf"></i>
                <h3 class="file__title">{{ item?.description }}</h3>
              </a>
            </div>
          </div>
        }
      </div>
    </section>
  </i-modal>
}
